import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

import { Modal } from 'dyl-components';
import masterAccountActions from 'actions/master_account';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import MasterAccountForm from 'shared/MasterAccountForm';
import AddAccountModal from "../modals/AddAccountModal";
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';

const mapStateToProps = state => ({
    isReading: state.master_account.isReadingLinkedAccounts,

    master_account: state.master_account.master_account
})

const mapDispatchToProps = dispatch => ({
    readMasterAccount: (id) => {
        dispatch(masterAccountActions.readOne(id));
    }
});

const DROPDOWN = [
    { key: 'new', value: 'new', text: 'Create new account', userPermission: USER_PERMISSIONS.ACCOUNT_ADD, productPermission: PRODUCT_PERMISSIONS.RECORDS},
    { key: 'nest', value: 'nest', text: 'Nest existing account(s)', userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_ADD, productPermission: '' },
]

const SubAccounts = ({
    isReading,

    master_account,
    readMasterAccount,

    triggerProps = {}
}) => {
    const { master_account_id } = useParams();

    const [linkAccountAction, setLinkAccountAction] = useState(null);
    const [isDirty, setIsDirty] = useState(false);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

    const openLinkAccountModal = (action) => {
        setLinkAccountAction(action);
    }

    const closeLinkAccountModal = () => {
        setLinkAccountAction(null);
    }

    const isLinkAccountModalOpen = (action) => {
        return action === linkAccountAction;
    }

    return (
        <React.Fragment>
            <Dropdown
                loading={isReading}
                {...triggerProps}
                value={linkAccountAction}
                selectOnBlur={false}
            >
                <Dropdown.Menu>
                    {DROPDOWN.map(item => (
                        <RestrictedView type="disabled" userPermission={item.userPermission} productPermission={item.productPermission}>
                            <Dropdown.Item onClick={() => { openLinkAccountModal(item.value) }}>
                                {item.text}
                            </Dropdown.Item>
                        </RestrictedView>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            <Modal open={isLinkAccountModalOpen('nest')} onClose={closeLinkAccountModal}>
                <MasterAccountForm
                    close={closeLinkAccountModal}
                    master_account={{
                        name: master_account?.name,
                        id: master_account_id
                    }}
                    refreshFromLinking={() => {
                        readMasterAccount(master_account_id)
                    }}
                    onDirtyChange={(dirty) => setIsDirty(dirty)}
                />
            </Modal>
            <Modal size='big' open={isLinkAccountModalOpen('new')} onClose={() => {
                isDirty
                    ? setIsConfirmationOpen(true)
                    : closeLinkAccountModal();
            }}>
                <AddAccountModal
                    account_type={'business'}
                    master_account_id={master_account_id}
                    refreshFromLinking={() => {
                        readMasterAccount(master_account_id)
                    }}
                    onClose={closeLinkAccountModal}
                    onDirtyChange={(dirty) => setIsDirty(dirty)}
                />
            </Modal>
            <FullScreenModalPopUp
                header={"Changes not saved"}
                subheader={"Are you sure you want to exit?"}
                isOpen={isConfirmationOpen}
                onConfirm={() => {
                    closeLinkAccountModal();
                    setIsConfirmationOpen(false);
                    setIsDirty(false)
                }}
                onFormClose={() => setIsConfirmationOpen(false)}
                closeIcon={false}
            />
        </React.Fragment>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SubAccounts);
